import { PublicClientApplication } from "@azure/msal-browser";

if (!process.env.REACT_APP_AZURE_CLIENT_ID)
  throw new Error("Missing REACT_APP_AZURE_CLIENT_ID");
if (!process.env.REACT_APP_AZURE_TENANT_ID)
  throw new Error("Missing REACT_APP_AZURE_TENANT_ID");
if (!process.env.REACT_APP_LHYST_API_SCOPE)
  throw new Error("Missing REACT_APP_LHYST_API_SCOPE");
if (!process.env.REACT_APP_REQUIRED_ROLES)
  throw new Error("Missing REACT_APP_REQUIRED_ROLES");

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const initializeMsal = async () => {
  if (!msalInstance.getAllAccounts().length) {
    console.log(" Initializing MSAL instance...");
    await msalInstance.initialize();
    console.log(" MSAL instance initialized.");
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "offline_access"],
};

export const tokenRequest = {
  scopes: [process.env.REACT_APP_LHYST_API_SCOPE],
};

export const REQUIRED_ROLES = process.env.REACT_APP_REQUIRED_ROLES.split(",");
